import React from 'react';
import NavigateRightUp from '@uber/base-icons/navigate-right-up';
type PropsT = {
  size?: number;
  strokeColor?: string;
  title?: string;
};
export function Select({
  size = 16,
  strokeColor,
  title
}: PropsT) {
  return <NavigateRightUp size={size} color={strokeColor} title={title} />;
}